module.exports = __webpack_public_path__ + "static/media/cover11.492515de.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/cover11.png
// module id = 564
// module chunks = 0